import { Skeleton } from '@heidi/design-system/skeleton';

export function PracticeInviteTeamModalLoading() {
  return (
    <div
      className="flex w-full flex-col items-center gap-6"
      data-testid="practice-invite-team-modal-loading"
    >
      <Skeleton className="size-12 rounded-lg" />
      <div className="flex w-full flex-col items-center gap-2">
        <Skeleton className="h-9 w-64 max-w-full" />
        <Skeleton className="h-5 w-48 max-w-full" />
      </div>
      <Skeleton className="h-10 w-full rounded-md" />
      <div className="flex w-full flex-col gap-4">
        <Skeleton className="h-6 w-72 max-w-full" />
        <Skeleton className="h-6 w-56 max-w-full" />
      </div>
      <Skeleton className="h-10 w-full rounded-md" />
      <Skeleton className="h-10 w-full rounded-md" />
    </div>
  );
}
